<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" :id="id">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="far fa-sticky-note"></i>
                        新規ノート
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="caption">
                        <input type="text" class="form-control input-caption b-normal shadow-none" ref="caption" v-model="note.caption" @keydown.enter="inputNote" maxlength="16" placeholder="ノートの見出し（16文字まで）">
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-outline-primary btn-sm" type="button" @click="save()" :disabled="!note.caption">
                        ノートを編集
                    </button>
                    <button class="btn btn-outline-secondary btn-sm" type="button" @click="cancel()">
                        キャンセル
                    </button>
                </div>
            </div>
        </div>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>

<style scoped lang="scss">
.caption {
    margin: .5rem 3rem;
    .input-caption {
        font-size: 2.2rem;
        border-bottom: 1px solid #aaa;
    }
}
</style>

<script>
export default {
    props: {
        id: {
            default: 'note-modal'
        }
    },
    data() {
        return {
            note: {},
            isMarkdown: false,
            outline: [],
            dontSave: false,
            isLoading: false,
        }
    },
    methods: {
        inputNote(ev) {
            if (ev.isComposing === false) {
                if (ev.ctrlKey || ev.metaKey) {
                    this.save();
                }
            }
        },
        load() {
            this.note = {
                caption: null
            };
        },
        focus() {
            if (!this.note.caption) {
                this.$refs.caption.focus();
            }
        },
        async save() {
            if (!this.note.caption) {
                return;
            }
            this.isLoading = true;
            axios.post("/mypage/book/note/save", this.note).then(res => {
                this.isLoading = false;
                $("#" + this.id).modal("hide");
                this.$emit("saved", res.data.id);
            }).catch(err => {
                alert.err(err.response);
                this.isLoading = false;
            });
        },
        cancel() {
            $("#" + this.id).modal("hide");
        },
    },
    mounted() {
        $("#note-modal").on("show.bs.modal", (e) => {
            this.load();
        });
        $("#note-modal").on("shown.bs.modal", (e) => {
            this.focus();
        });
    }
}
</script>